import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { Fragment } from 'react/jsx-runtime';
import { QueryResultsTableSkeleton } from '../queryResultsTable/QueryResultTableSkeletons';

// Top row: Vertical bar skeletons representing a bar graph
export const QueryHistogramSkeleton = () => {
  return (
    <div className="margin-auto flex max-h-[64px] items-end gap-2 p-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <Fragment key={`bar-${i}`}>
          <Skeleton key={`bar1-${i}`} className="h-8 w-4 rounded-sm" />
          <Skeleton key={`bar2-${i}`} className="h-10 w-4 rounded-sm" />
          <Skeleton key={`bar3-${i}`} className="h-6 w-4 rounded-sm" />
          <Skeleton key={`bar4-${i}`} className="h-[32px] w-4 rounded-sm" />
          <Skeleton key={`bar5-${i}`} className="h-8 w-4 rounded-sm" />
          <Skeleton key={`bar6-${i}`} className="h-12 w-4 rounded-sm" />
          <Skeleton key={`bar7-${i}`} className="h-[20px] w-4 rounded-sm" />
          <Skeleton key={`bar8-${i}`} className="h-10 w-4 rounded-sm" />
          <Skeleton key={`bar9-${i}`} className="h-8 w-4 rounded-sm" />
          <Skeleton key={`bar10-${i}`} className="h-[32px] w-4 rounded-sm" />
          <Skeleton key={`bar11-${i}`} className="h-6 w-4 rounded-sm" />
          <Skeleton key={`bar12-${i}`} className="h-[22px] w-4 rounded-sm" />
          <Skeleton key={`bar13-${i}`} className="h-10 w-4 rounded-sm" />
          <Skeleton key={`bar14-${i}`} className="h-8 w-4 rounded-sm" />
          <Skeleton key={`bar15-${i}`} className="h-12 w-4 rounded-sm" />
          <Skeleton key={`bar16-${i}`} className="h-10 w-4 rounded-sm" />
        </Fragment>
      ))}
    </div>
  );
};

export function QueryRunningSkeletons() {
  return (
    <div className="flex flex-col gap-0">
      <QueryHistogramSkeleton />
      <QueryResultsTableSkeleton />
    </div>
  );
}
